import Header from "../components/Header";
import React from "react";
import Footer from "./Footer";
import ReactGA from "react-ga4";
import {useLocation} from "react-router-dom";
import {useEffect} from "react";

const News: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return (
    <div className="bg-white flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-col w-[84%] mx-auto flex-grow">
        <div className="my-3">
          <div className="font-bold text-[28px] lg:text-[37.5px] text-[#2A424B] my-3 py-4">
            News
          </div>
          <div className="text-valmidnight text-[16px]">
            <ul className="list-disc list-outside pl-5 space-y-4">
              <li className="text-black text-[16px]">
                <div className="grid grid-cols-[1fr_auto] items-start gap-4">
                  <span className="min-w-0">
                    EARTH-HCM version 2 is live. This major update includes the
                    addition of the Comparator page, which allows you to make
                    more user-friendly direct comparisons between two groups of
                    interest.
                  </span>
                  <span className="text-[14px] text-gray-500 whitespace-nowrap">
                    April 2, 2026
                  </span>
                </div>
              </li>
              <li className="text-black text-[16px]">
                <div className="grid grid-cols-[1fr_auto] items-start gap-4">
                  <span className="min-w-0">
                    <a href="/research" className="hover:underline">
                      Our open access publication on the epidemiology of HCM in
                      the US from 2016 to 2023 is now available to be read in
                      JACC: Advances.
                    </a>
                  </span>
                  <span className="text-[14px] text-gray-500 whitespace-nowrap">
                    Jan 23, 2026
                  </span>
                </div>
              </li>
              <li className="text-black text-[16px]">
                <div className="grid grid-cols-[1fr_auto] items-start gap-4">
                  <span className="min-w-0">
                    <a
                      href="https://ir.cytokinetics.com/press-releases/press-release-details/2025/Cytokinetics-Announces-Launch-of-EARTH-HCM-a-Public-Health-Education-Tool-for-the-Hypertrophic-Cardiomyopathy-Community-03-20-2025/default.aspx"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline">
                      EARTH-HCM version 1 is live.
                    </a>
                  </span>
                  <span className="text-[14px] text-gray-500 whitespace-nowrap">
                    March 20, 2025
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default News;
